import { useQueryClient } from '@tanstack/react-query';

import { useFormMutation } from 'mutations/useFormMutation';

export function useMutateReverter() {
    const { mutate, isLoading } = useFormMutation();
    const queryClient = useQueryClient();

    /**
     * Reverte o reembolso da apuração.
     */
    const handleReverter = (idApuracao: number) => {
        mutate(
            {
                url: `/financeiro/apuracao/reverte?idApuracao=${idApuracao}`,
            },
            {
                onSuccess: () => queryClient.invalidateQueries(['queryApuracoes']),
            },
        );
    };

    return { handleReverter, isLoading };
}
